import React from "react";
import { Link } from "react-router-dom";
import SectionLayout from "@/pages/SectionLayout";
import DOCUMENTS from "@/data/repository";

const RepositoryIndex = () => {
  const single = DOCUMENTS.length === 1;
  return (
    <SectionLayout>
      <h2
        className="glass-panel__title glass-panel__title--lower"
        data-testid="section-title"
      >
        the vault that holds many thoughts
      </h2>

      <div
        className={`vault-grid${single ? " vault-grid--single" : ""}`}
        data-testid="vault-grid"
      >
        {DOCUMENTS.map((d) => (
          <Link
            key={d.id}
            to={`/repository/${d.id}`}
            className="collection-box collection-box--active"
            data-testid={`vault-${d.id}`}
          >
            <span className="collection-box__index">{d.index}</span>
            <span className="collection-box__title">{d.title}</span>
          </Link>
        ))}
      </div>

      <div className="glass-panel__nav">
        <Link to="/" className="glass-panel__btn" data-testid="btn-home">
          Home
        </Link>
      </div>
    </SectionLayout>
  );
};

export default RepositoryIndex;
